import { render, staticRenderFns } from "./StudentDetailModal.vue?vue&type=template&id=308a3dd9&scoped=true"
import script from "./StudentDetailModal.vue?vue&type=script&lang=js"
export * from "./StudentDetailModal.vue?vue&type=script&lang=js"
import style0 from "./StudentDetailModal.vue?vue&type=style&index=0&id=308a3dd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308a3dd9",
  null
  
)

export default component.exports